var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$company.setting
    ? _c("div", { staticClass: "tile is-ancestor is-parent" }, [
        _c("div", { staticClass: "tile is-parent pl-1" }, [
          _c("section", { staticClass: "tile is-child box businessHours" }, [
            _c("div", { staticClass: "subtitle" }, [_vm._v("Business Hours")]),
            _vm._m(0),
            _c("div", { staticClass: "field is-horizontal" }, [
              _vm._m(1),
              _c("div", { staticClass: "field" }, [
                _c(
                  "div",
                  { staticClass: "control" },
                  [
                    _c("the-mask", {
                      staticClass: "input",
                      attrs: { placeholder: "e.g. 30", mask: ["###"] },
                      model: {
                        value: _vm.businessHourTimeSlot,
                        callback: function ($$v) {
                          _vm.businessHourTimeSlot = $$v
                        },
                        expression: "businessHourTimeSlot",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._m(2),
            _c(
              "div",
              { staticClass: "field" },
              _vm._l(_vm.daysOfWeek, function (day, index) {
                return _c("div", { key: index, staticClass: "columns" }, [
                  _c("div", { staticClass: "column" }, [
                    _c(
                      "div",
                      { staticClass: "is-flex is-flex-direction-column" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "control",
                            staticStyle: { width: "5em" },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "pretty p-switch p-fill" },
                              [
                                _c("input", {
                                  attrs: { type: "checkbox" },
                                  domProps: { checked: day.isBusinessDay },
                                  on: {
                                    change: function ($event) {
                                      return _vm.handleToggleBusinessDay(day)
                                    },
                                  },
                                }),
                                _c("div", { staticClass: "state p-primary" }, [
                                  _c("label", [_vm._v(_vm._s(day.name))]),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "column is-2" }, [
                    _c("div", { staticClass: "field" }, [
                      _c(
                        "div",
                        { staticClass: "control" },
                        [
                          _c("the-mask", {
                            staticClass: "input",
                            attrs: {
                              placeholder: "e.g. 6",
                              mask: ["##"],
                              content:
                                "Required. Must be greater than 0 and less than 99.",
                              disabled: !day.isBusinessDay,
                            },
                            model: {
                              value: _vm.hours[day.name].productionSlot,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.hours[day.name],
                                  "productionSlot",
                                  $$v
                                )
                              },
                              expression: "hours[day.name].productionSlot",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "column" },
                    [
                      _c("v-date-picker", {
                        ref: "datepicker",
                        refInFor: true,
                        staticClass: "is-fullwidth",
                        attrs: {
                          "is-dark": _vm.$theme.isDark,
                          mode: "time",
                          "minute-increment": 5,
                          masks: _vm.formats,
                          attributes: _vm.attrs,
                          locale: _vm.$userInfo.locale,
                          "model-config": _vm.hours[day.name].open
                            ? {}
                            : _vm.modelConfig,
                          timezone: _vm.$filters.getIanaTimezone(),
                          disabled: !day.isBusinessDay,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ inputValue, inputEvents }) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "field has-addons" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "control is-expanded has-icons-left",
                                        },
                                        [
                                          _c(
                                            "input",
                                            _vm._g(
                                              {
                                                ref: "day.name",
                                                refInFor: true,
                                                staticClass: "input",
                                                attrs: {
                                                  type: "text",
                                                  placeholder: "Start Time",
                                                  readonly: "",
                                                  disabled: !day.isBusinessDay,
                                                },
                                                domProps: { value: inputValue },
                                              },
                                              inputEvents
                                            )
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "icon is-small is-left",
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "mdi mdi-calendar mdi-18px",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.hours[day.name].open,
                          callback: function ($$v) {
                            _vm.$set(_vm.hours[day.name], "open", $$v)
                          },
                          expression: "hours[day.name].open",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "column" },
                    [
                      _c("v-date-picker", {
                        ref: "datepicker",
                        refInFor: true,
                        staticClass: "is-fullwidth",
                        attrs: {
                          "is-dark": _vm.$theme.isDark,
                          mode: "time",
                          "minute-increment": 5,
                          masks: _vm.formats,
                          attributes: _vm.attrs,
                          locale: _vm.$userInfo.locale,
                          "model-config": _vm.hours[day.name].close
                            ? {}
                            : _vm.modelConfig,
                          timezone: _vm.$filters.getIanaTimezone(),
                          disabled: !day.isBusinessDay,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ inputValue, inputEvents }) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "field has-addons" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "control is-expanded has-icons-left",
                                        },
                                        [
                                          _c(
                                            "input",
                                            _vm._g(
                                              {
                                                ref: "day.name",
                                                refInFor: true,
                                                staticClass: "input",
                                                attrs: {
                                                  type: "text",
                                                  placeholder: "Close Time",
                                                  readonly: "",
                                                  disabled: !day.isBusinessDay,
                                                },
                                                domProps: { value: inputValue },
                                              },
                                              inputEvents
                                            )
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "icon is-small is-left",
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "mdi mdi-calendar mdi-18px",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.hours[day.name].close,
                          callback: function ($$v) {
                            _vm.$set(_vm.hours[day.name], "close", $$v)
                          },
                          expression: "hours[day.name].close",
                        },
                      }),
                    ],
                    1
                  ),
                ])
              }),
              0
            ),
            _c("div", { staticClass: "fields" }, [
              _c("div", { staticClass: "buttons" }, [
                _c(
                  "button",
                  {
                    staticClass: "button is-primary tooltip",
                    attrs: { "data-tooltip": "Save" },
                    on: { click: _vm.saveHours },
                  },
                  [_vm._m(3), _c("span", [_vm._v("Save")])]
                ),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "tile is-parent pl-1" }, [
          _c(
            "section",
            { staticClass: "tile is-child box" },
            [
              _c("div", { staticClass: "subtitle" }, [
                _vm._v("Override Business Hours Listing"),
              ]),
              _c("company-override-business-hours"),
            ],
            1
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field is-hidden" }, [
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column" }, [
          _c(
            "span",
            {
              staticClass:
                "tag is-info is-light is-pulled-right has-text-weight-bold",
            },
            [_vm._v("** Each slot is duration of 30 minutes.")]
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field-label is-normal" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Time Slot (minutes)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field" }, [
      _c("div", { staticClass: "columns field" }, [
        _c("div", { staticClass: "column" }),
        _c("div", { staticClass: "column has-text-weight-bold is-2" }, [
          _vm._v(" Slots "),
        ]),
        _c("div", { staticClass: "column has-text-weight-bold" }, [
          _vm._v(" Start Time "),
        ]),
        _c("div", { staticClass: "column has-text-weight-bold" }, [
          _vm._v(" Close Time "),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-content-save mdi-20px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }